import { Briefcase, CheckCircle, AlertTriangle, X } from 'lucide-react'
import React, { useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { BASE_URL_API } from '../../References/urls'
import AuthContext from '../../store/auth-context'
import styles from './MarkHiredModal.module.css'

const MarkHiredModal = ({ isOpen, onClose, referralDetails, applicationData, onSuccess }) => {
    const authCtx = useContext(AuthContext)
    const [joiningDate, setJoiningDate] = useState('')
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [dateError, setDateError] = useState('')
    const [inlineError, setInlineError] = useState('')
    const [successData, setSuccessData] = useState(null)

    useEffect(() => {
        if (isOpen && applicationData?.joiningDate) {
            const datePart = applicationData.joiningDate.split(' ')[0]
            setJoiningDate(datePart === '0000-00-00' ? '' : datePart)
        }
    }, [isOpen])

    if (!isOpen) return null

    const handleConfirm = async () => {
        if (!joiningDate) {
            setDateError('Joining date required')
            return
        }
        setDateError('')
        setInlineError('')
        setIsSubmitting(true)

        try {
            const response = await fetch(BASE_URL_API + "/referralMarkHired", {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    userIdentifier: authCtx.userIdentifier,
                    referralId: referralDetails.referralId,
                    storeIdentifier: applicationData.store_id,
                    joiningDate: joiningDate
                })
            })

            if (!response.ok) {
                setInlineError("Save nahi hua. Retry karo.")
                setIsSubmitting(false)
                return
            }

            const respo = await response.json()

            if (respo.success === true) {
                setSuccessData(respo.response)
                onSuccess()
            } else {
                const errorType = respo.response?.errorType
                if (errorType === "INVALID_DATE") {
                    setDateError("Joining date aaj ya pehle ki honi chahiye.")
                } else if (errorType === "ALREADY_HIRED") {
                    toast("Candidate already hired mark hai.")
                    onSuccess()
                    onClose()
                } else if (errorType === "NOT_HIREABLE") {
                    toast.warn("Is candidate ko hire mark nahi kar sakte. Status check karo — verification complete hona chahiye.")
                    onClose()
                } else {
                    setInlineError("Save nahi hua. Retry karo.")
                }
            }
        } catch {
            setInlineError("Save nahi hua. Retry karo.")
        }

        setIsSubmitting(false)
    }

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                {successData ? (
                    <div className={styles.successState}>
                        <div className={styles.successBanner}>
                            <div className={styles.successTitle}>
                                <CheckCircle size={18} />
                                Hired confirmed!
                            </div>
                            <div>₹{successData.joiningRewardAmount} — {referralDetails.referred_by_code} ke wallet mein add ho gaya (available)</div>
                            <div>₹{successData.retentionRewardAmount} — Pending mein show ho raha hai (15 din baad milega)</div>
                        </div>
                        <button className={styles.closeBtn} onClick={onClose}>Close</button>
                    </div>
                ) : (
                    <>
                        <div className={styles.modalHeader}>
                            <Briefcase size={18} />
                            Mark Candidate as Hired
                        </div>

                        <div className={styles.infoRow}>
                            <span className={styles.infoLabel}>Candidate:</span>
                            <strong>{applicationData.stylist_name}</strong>
                        </div>
                        <div className={styles.infoRow}>
                            <span className={styles.infoLabel}>Referred by:</span>
                            <strong>{referralDetails.referred_by_code}</strong>
                            <span className={styles.stylistIdChip}>{referralDetails.referred_by_stylist_id}</span>
                        </div>
                        <div className={styles.infoRow}>
                            <span className={styles.infoLabel}>Salon:</span>
                            <strong>{applicationData.company_name}</strong>
                        </div>

                        <div className={styles.fieldWrapper}>
                            <label className={styles.fieldLabel}>Joining Date</label>
                            <input
                                type="date"
                                value={joiningDate}
                                readOnly
                                className={`${styles.dateInput} ${styles.dateInputReadonly} ${dateError ? styles.inputError : ''}`}
                            />
                            {dateError && <div className={styles.errorText}>{dateError}</div>}
                        </div>

                        <div className={styles.rewardNote}>
                            <div className={styles.rewardNoteTitle}>Yeh action karne se:</div>
                            <div>• ₹500 referrer ke wallet mein add hoga (now)</div>
                            <div>• ₹1,000 pending mein show hoga (15 din baad)</div>
                        </div>

                        {inlineError && (
                            <div className={styles.inlineError}>
                                <AlertTriangle size={14} />
                                {inlineError}
                            </div>
                        )}

                        <div className={styles.actions}>
                            <button className={styles.cancelBtn} onClick={onClose} disabled={isSubmitting}>
                                <X size={14} />
                                Cancel
                            </button>
                            <button
                                className={styles.confirmBtn}
                                onClick={handleConfirm}
                                disabled={isSubmitting}
                            >
                                <CheckCircle size={14} />
                                {isSubmitting ? 'Processing...' : 'Confirm Hiring'}
                            </button>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}

export default MarkHiredModal
